import { use } from 'react';
import { VoiceCallActionsContext } from './voice-call-actions-provider';

export const useVoiceCallActions = () => {
  const context = use(VoiceCallActionsContext);
  if (!context) {
    throw new Error('useVoiceCallActions must be used within VoiceCallActionsProvider');
  }
  return context;
};
